import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from '../actions/sessionActions';

import { 
  Switch,
  Route,
  Redirect,
  Link,
  NavLink,
  withRouter,
} from 'react-router-dom';

import Sidebar from './Sidebar'
import Header from './Header'
import Modal from './Modal'

import Overview from './Overview';
import ProfilePage from './ProfilePage';
import SegmentingPage from './SegmentingPage';
import CampaignsPage from './CampaignsPage';
import CampaignPage from './CampaignPage';
import FansPage from './FansPage';
import EventsPage from './EventsPage';
import EventPage from './EventPage';
// import NoMatch from './NoMatch';

import logo from '../images/festivality-logo-bird.png'

class Home extends Component {
  logOut = (ev) => {
    const { logout } = this.props;
    logout(this.props.history);
  }

  render() {
    return (
      <div className="dashboard flex">
        <Sidebar logout={this.logOut}/>
        <div className="dashb">
          <Header/>
          <Switch>
            {/* <Redirect exact from="/" to="/dashboard"/> */}
            <Route exact path="/" component={Overview}/>
            <Route path="/dashboard" component={CampaignsPage}/>
            <Route path="/fans" component={FansPage}/>
            <Route path="/segmenting/:request" component={SegmentingPage}/>
            <Route path="/campaigns" component={CampaignsPage}/>
            <Route exact path="/campaign/:id" component={CampaignPage}/>
            <Route path="/events" component={EventsPage}/>
            <Route exact path="/event/:id" component={EventPage}/>
            <Redirect exact from="/campaign/:id/:smth" to="/campaigns"/>
            <Route path="/profile" component={ProfilePage}/>
            <Redirect to="/"/>
            {/* <Route component={NoMatch}/> */}
          </Switch>
        </div>
        <Modal/>
      </div>
    );
  }
}

export default withRouter(connect(null, { logout })(Home))


// WEBPACK FOOTER //
// ./src/components/Home.js